import { render } from "./BankAccountEdit.vue?vue&type=template&id=5819a1a9&ts=true"
import script from "./BankAccountEdit.vue?vue&type=script&lang=ts"
export * from "./BankAccountEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__